module.exports = __webpack_public_path__ + "img/class.98c7ca26.svg";